@if (customerCareDetails) {
  <h3 class="text-center width-100">
    <small>Customer Care</small>
    <i
      class="fa fa-times pull-right close-sidenav"
      aria-hidden="true"
      title="Close Customer Care"
      (click)="closeNav()"
    ></i>
  </h3>
  <div class="container-fluid maxWidth-400 control-panel">
    <form (ngSubmit)="submitCustomerCareForm()" [formGroup]="editCustomerCareForm" novalidate>
      <div class="edit row">
        <div class="col-12">
          <div style="width: 100%">
            <label for="ccHeaderHtml"
              ><h6 class="sub_header margin-20-0">
                1. Customer Care Header Text
                <div>({{ custHeaderMaxCharStr }})</div>
              </h6></label
            ><br />
            <medium-editor-shared
              id="ccHeaderHtml"
              #mediumEditor
              [innerHTMLText]="customerCareDetails.customerCareHeaderHtml"
              [location]="'customerCare'"
            ></medium-editor-shared>
          </div>
        </div>
      </div>
      @if (editCustomerCareForm) {
        <div class="edit-row">
          <div class="col-12 margin-5-0">
            <h6 class="sub_header margin-20-0">2. Customer portal configuration</h6>
            <div class="form-check margin-bottom-20">
              <label for="isCustomerPortal" class="form-check-label">
                <input
                  type="checkbox"
                  class="form-check-input input_checkbox"
                  id="isCustomerPortal"
                  name="isCustomerPortal"
                  formControlName="isCustomerPortal"
                />Display customer portal details.
              </label>
            </div>
            <div class="form-group">
              <label for="ccPortalText">Customer portal text</label><br />
              <input
                type="text"
                class="form-control color"
                id="ccPortalText"
                aria-describedby="Customer portal text"
                placeholder="Customer portal text"
                name="ccPortalText"
                formControlName="customerPortalText"
              />
              @if (customerPortalText?.invalid) {
                <div>
                  <small>{{ maxCharStr }}</small>
                </div>
              }
            </div>
            <div class="form-group">
              <label for="ccPortalLabel">Customer portal Link label</label><br />
              <input
                type="text"
                class="form-control color"
                id="ccPortalLabel"
                aria-describedby="Customer portal link Label"
                placeholder="Customer portal link label"
                name="ccPortalLabel"
                formControlName="customerPortalLinkLabel"
              />
              @if (customerPortalLinkLabel?.invalid) {
                <div>
                  <small>{{ maxCharStr }}</small>
                </div>
              }
            </div>
            <div class="form-group">
              <label for="ccPortalLink">Customer portal link</label><br />
              <input
                type="text"
                class="form-control color"
                id="ccPortalLink"
                aria-describedby="Customer portal label"
                placeholder="Customer portal label"
                name="ccPortalLink"
                formControlName="customerPortalLink"
              />
              @if (customerPortalLink?.invalid) {
                <div>
                  <small>add a valid url with http:// or https://</small>
                </div>
              }
            </div>
          </div>
          <div class="col-12 margin-5-0">
            <h6 class="sub_header margin-20-0">3. Customer contact configuration</h6>
            <div class="form-group">
              <label for="phoneNumber">Phone Number</label><br />
              <input
                type="text"
                class="form-control color"
                id="phoneNumber"
                aria-describedby="Phone Number"
                placeholder="Enter phone number"
                name="phoneNumber"
                formControlName="phoneNumber"
              />
              @if (phoneNumber?.invalid) {
                <div><small>10 digit number only</small></div>
              }
            </div>
            <div class="form-group">
              <label for="emailAddressText">Email Address Text</label><br />
              <input
                type="text"
                class="form-control color"
                id="emailAddressText"
                aria-describedby="Enter email address text"
                placeholder="Enter email address text"
                name="emailAddressText"
                formControlName="emailAddressText"
              />
              @if (emailAddressText?.invalid) {
                <div>
                  <small>{{ maxCharStr }}</small>
                </div>
              }
            </div>
            <div class="form-group">
              <label for="emailAddress">Email Address</label><br />
              <input
                type="email"
                class="form-control color"
                id="emailAddress"
                aria-describedby="Enter email address"
                placeholder="Enter email address"
                name="emailAddress"
                formControlName="emailAddress"
              />
              @if (emailAddress?.invalid) {
                <div>
                  <small>please enter a valid email address</small>
                </div>
              }
            </div>
            <div class="form-group">
              <label for="timings">Customer Contact Text</label><br />
              <input
                type="text"
                class="form-control color"
                id="timings"
                aria-describedby="Enter customer contact text"
                placeholder="Enter customer contact text"
                name="timings"
                formControlName="timingsText"
              />
              @if (timingsText?.invalid) {
                <div>
                  <small>{{ maxCharStr }}</small>
                </div>
              }
            </div>
          </div>
          <div class="col-12 margin-5-0">
            <h6 class="sub_header margin-20-0">4. Customer survey configuration</h6>
            <div class="form-check margin-bottom-20">
              <label for="isCustomerSurvey" class="form-check-label">
                <input
                  type="checkbox"
                  class="form-check-input input_checkbox"
                  id="isCustomerSurvey"
                  name="isCustomerSurvey"
                  formControlName="isCustomerSurvey"
                />Display customer survey details.
              </label>
            </div>
            <div class="form-group">
              <label for="ccSurveyText">Customer Survey Text</label><br />
              <input
                type="text"
                class="form-control color"
                id="ccSurveyText"
                aria-describedby="Customer survey text"
                placeholder="Enter customer survey text"
                name="ccSurveyText"
                formControlName="customerSurveyText"
              />
              @if (customerSurveyText?.invalid) {
                <div>
                  <small>{{ maxCharStr }}</small>
                </div>
              }
            </div>
            <div class="form-group">
              <label for="ccSurveyLinkLabel">Customer Survey Link Label</label><br />
              <input
                type="text"
                class="form-control color"
                id="ccSurveyLinkLabel"
                aria-describedby="Customer survey link label"
                placeholder="Enter customer survey link label"
                name="ccSurveyLinkLabel"
                formControlName="customerSurveyLinkLabel"
              />
              @if (customerSurveyLinkLabel?.invalid) {
                <div>
                  <small>{{ maxCharStr }}</small>
                </div>
              }
            </div>
            <div class="form-group">
              <label for="timings">Customer Survey Link</label><br />
              <input
                type="text"
                class="form-control color"
                id="ccSurveyLink"
                aria-describedby="Customer survey link"
                placeholder="Enter customer survey link"
                name="ccSurveyLink"
                formControlName="customerSurveyLink"
              />
              @if (customerSurveyLink?.invalid) {
                <div>
                  <small>add a valid url with http:// or https://</small>
                </div>
              }
            </div>
          </div>
          <div class="col-12 margin-5-0">
            <h6 class="sub_header margin-20-0">5. Form Submit configuration</h6>
            <div class="form-group">
              <label for="toEmailAddressOnSubmit">To email address on form submit</label><br />
              <input
                type="email"
                class="form-control color"
                id="toEmailAddressOnSubmit"
                aria-describedby="To email address on form submit"
                placeholder="To email address on form submit"
                name="toEmailAddressOnSubmit"
                formControlName="toEmailAddressOnSubmit"
              />
              @if (toEmailAddressOnSubmit?.invalid) {
                <div>
                  <small>please enter a valid email address</small>
                </div>
              }
            </div>
          </div>
          <div class="edit row">
            <div class="col-12 margin-25-0 text-end">
              <button
                role="button"
                aria-label="Save and Close"
                class="btn btn-primary"
                style="left: initial"
                type="submit"
                [disabled]="!editCustomerCareForm.valid"
                [ngClass]="{ 'greyed-out': !editCustomerCareForm.valid }"
              >
                Save and Close
              </button>
            </div>
          </div>
        </div>
      }
    </form>
  </div>
}
